import StaticModal from 'shared/common/modal/staticModal';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { useState } from 'react';

import hidden from '../../assets/images/hidden.png';
import eye from '../../assets/images/eye.png';
import infoIco from 'assets/images/i-circle.svg';
import { Button } from 'react-bootstrap';
import { CognitoUser } from 'amazon-cognito-identity-js';
import LoginService from './services/login.service';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { userStore } from 'store/UserStore';
import api from 'api/client';

type Props = {
  show: boolean;
  cognitoUser: CognitoUser;
  userData: any;
  onClose?: () => void;
};

const PasswordUpdate = ({ show, cognitoUser, userData, onClose }: Props) => {
  const [isShowPwd, setShowPwd] = useState(false);
  const [isShowConfPwd, setShowConfPwd] = useState(false);
  const [password, setPassword] = useState('');
  const history = useHistory();
  const { setLoginData } = userStore();
  const onSuccess = async (password: any) => {
    setPassword(password);
    try {
      if (userData && cognitoUser) {
        const res: any = await LoginService.forceChangePassword(
          userData,
          cognitoUser,
          password
        );
        console.log('onSuccess // res:', res);

        if (res) {
          setLoginData({
            customer: {},
            customerId: '',
            selectedAccount: {},
            user: {},
            tokens: {
              accessToken: res.getAccessToken(),
              idToken: res.getIdToken(),
              refreshToken: res.getRefreshToken(),
            },
            userData: res.getIdToken().decodePayload(),
          });
          api.setAuthAccess(res.accessToken.jwtToken);
          api.setAuthRefresh(res.refreshToken.token);
          api.setToken(res.idToken.jwtToken);

          history.push('/customers');
        }
      }
    } catch (err: any) {
      console.log(err);
      toast.error(err.message);
    }
  };
  return (
    <StaticModal show={show} title='New Passsword Required' onClose={onClose}>
      <Formik
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(false);
          onSuccess(values.password);
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .required('Password is required')
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
              'The password must be at least 8 characters and it must contain at least one uppercase, one lowercase, one number and one special character.'
            ),
          confirmPassword: Yup.string()
            .required('confirm Password is required')
            .matches(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
              'The password must be at least 8 characters and it must contain at least one uppercase, one lowercase, one number and one special character.'
            ),
        })}
      >
        {({ isSubmitting, errors, touched, setFieldValue }) => (
          <Form translate={undefined}>
            <div className='form-group mb-2'>
              <label className='form-label'>New Password</label>
              <div className='input-group mb-3'>
                <Field
                  type={isShowPwd ? 'text' : 'password'}
                  placeholder='Password'
                  name='password'
                  style={{ position: 'unset' }}
                  className='form-control'
                />
                <div
                  className='input-group-text'
                  id='basic-addon1'
                  style={{
                    border: '1px solid #ced4da',
                    borderLeft: '0px',
                    backgroundColor: 'white',
                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                  }}
                >
                  <a href='#' onClick={() => setShowPwd(!isShowPwd)}>
                    <img
                      className='m-2'
                      style={{ width: '16px' }}
                      src={isShowPwd ? hidden : eye}
                      alt=''
                    />
                  </a>
                </div>
              </div>
              {/* <div className='error'>
                        {formShow && errors.password && touched.password && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.password}
                          </small>
                        )}
                      </div> */}
              <div className='form-group'>
                <div className='error-password'>
                  {errors.password && touched.password && (
                    <small id='my-helper-text'>
                      <img src={infoIco} alt='' />
                      {errors.password}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className='form-group mb-2'>
              <label className='form-label'> Confirm New Password</label>
              <div className='input-group mb-3'>
                <Field
                  type={isShowConfPwd ? 'text' : 'password'}
                  placeholder='confirm Password'
                  name='confirmPassword'
                  style={{ position: 'unset' }}
                  className='form-control'
                />
                <div
                  className='input-group-text'
                  id='basic-addon1'
                  style={{
                    border: '1px solid #ced4da',
                    borderLeft: '0px',
                    backgroundColor: 'white',
                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                  }}
                >
                  <a href='#' onClick={() => setShowConfPwd(!isShowConfPwd)}>
                    <img
                      className='m-2'
                      style={{ width: '16px' }}
                      src={isShowConfPwd ? hidden : eye}
                      alt=''
                    />
                  </a>
                </div>
              </div>
              {/* <div className='error'>
                        {formShow && errors.password && touched.password && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.password}
                          </small>
                        )}
                      </div> */}
              <div className='form-group'>
                <div className='error-password'>
                  {errors.confirmPassword && touched.confirmPassword && (
                    <small id='my-helper-text'>
                      <img src={infoIco} alt='' />
                      {errors.confirmPassword}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <Button className='w-100 mt-3' variant='primary' type='submit'>
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </StaticModal>
  );
};

export default PasswordUpdate;
